import * as dayjs from "dayjs";
import React, { Component } from "react";
import { Table, Button } from "react-bootstrap";
import { LinkContainer } from 'react-router-bootstrap';

import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime)

class SetupListTable extends Component {
    
    render() {
        return (
        <Table>
            <tbody>
            {this.props.departments.map((dept, index) =>
                <tr key={index}>
                    <td>{dept.school}</td>
                    <td>{dept.name}</td>
                    <td className="text-muted" style={{textAlign: "left"}}>
                        <span>
                            {dept.setup && dept.setup.auditInfo.dateModified
                                ? <>
                                { 'Modified ' + dayjs(dept.setup.auditInfo.dateModified).fromNow() }
                                </>
                                : <></>
                            }
                        </span>
                    </td>
                    <td style={{textAlign: "right"}}>
                    { dept.setup
                        ? <></>
                        : <LinkContainer 
                            to={{
                                pathname: '/setup/new',
                                search: '?d=' + dept.id,
                            }}
                            >
                            <Button
                                href={'/setup/new?d=' + dept.id}
                                variant="success"
                                size="md"
                                >
                                Create
                            </Button>
                        </LinkContainer>
                    }
                    { dept.setup
                        ? <> <LinkContainer
                                    to={'/setup/edit/' + dept.setup.setupId}
                                >
                            <Button
                                href={'/setup/edit/' + dept.setup.setupId}
                                size="md"
                                >
                                Modify
                            </Button>
                        </LinkContainer>
                        &nbsp;&nbsp;
                        <LinkContainer to={'/setup/view/' + dept.setup.setupId}>
                            <a href={'/setup/view/' + dept.setup.setupId}
                                className="btn btn-outline-primary pull-right" role="button">View</a>
                        </LinkContainer>
                        </>
                        : <></>
                    }
                    </td>
                </tr>
            )}
            </tbody>
        </Table>
        )
    }
}

export default SetupListTable;